import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'media-api.vendasta-local.com',
  'test': '',
  'demo': 'media-api-demo.apigateway.co',
  'prod': 'media-api-prod.apigateway.co',
  'production': 'media-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Tag {
  static fromProto(proto) {
    let m = new Tag();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Video {
  static fromProto(proto) {
    let m = new Video();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    return toReturn;
  }
}
class Image {
  static fromProto(proto) {
    let m = new Image();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    return toReturn;
  }
}
class CreateImageRequest {
  static fromProto(proto) {
    let m = new CreateImageRequest();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.servingUrl !== 'undefined') {
      toReturn['servingUrl'] = this.servingUrl;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
class CreateImageResponse {
  static fromProto(proto) {
    let m = new CreateImageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.imageId !== 'undefined') {
      toReturn['imageId'] = this.imageId;
    }
    return toReturn;
  }
}
class CreateVideoRequest {
  static fromProto(proto) {
    let m = new CreateVideoRequest();
    m = Object.assign(m, proto);
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.videoUrl !== 'undefined') {
      toReturn['videoUrl'] = this.videoUrl;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
class CreateVideoResponse {
  static fromProto(proto) {
    let m = new CreateVideoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.videoId !== 'undefined') {
      toReturn['videoId'] = this.videoId;
    }
    return toReturn;
  }
}
class GenerateUploadUrlRequest {
  static fromProto(proto) {
    let m = new GenerateUploadUrlRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.fileName !== 'undefined') {
      toReturn['fileName'] = this.fileName;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    return toReturn;
  }
}
class GenerateUploadUrlResponse {
  static fromProto(proto) {
    let m = new GenerateUploadUrlResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.signedUrl !== 'undefined') {
      toReturn['signedUrl'] = this.signedUrl;
    }
    return toReturn;
  }
}
class GetImageRequest {
  static fromProto(proto) {
    let m = new GetImageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.imageId !== 'undefined') {
      toReturn['imageId'] = this.imageId;
    }
    return toReturn;
  }
}
class GetImageResponse {
  static fromProto(proto) {
    let m = new GetImageResponse();
    m = Object.assign(m, proto);
    if (proto.image) {
      m.image = Image.fromProto(proto.image);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.image !== 'undefined' && this.image !== null) {
      toReturn['image'] = 'toApiJson' in this.image ? this.image.toApiJson() : this.image;
    }
    return toReturn;
  }
}
class GetResumableUploadSessionRequest {
  static fromProto(proto) {
    let m = new GetResumableUploadSessionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaType !== 'undefined') {
      toReturn['mediaType'] = this.mediaType;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    return toReturn;
  }
}
class GetResumableUploadSessionResponse {
  static fromProto(proto) {
    let m = new GetResumableUploadSessionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sessionUri !== 'undefined') {
      toReturn['sessionUri'] = this.sessionUri;
    }
    return toReturn;
  }
}
class GetVideoRequest {
  static fromProto(proto) {
    let m = new GetVideoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.videoId !== 'undefined') {
      toReturn['videoId'] = this.videoId;
    }
    return toReturn;
  }
}
class GetVideoResponse {
  static fromProto(proto) {
    let m = new GetVideoResponse();
    m = Object.assign(m, proto);
    if (proto.video) {
      m.video = Video.fromProto(proto.video);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.video !== 'undefined' && this.video !== null) {
      toReturn['video'] = 'toApiJson' in this.video ? this.video.toApiJson() : this.video;
    }
    return toReturn;
  }
}

// *********************************

// *********************************
let MediaApiService$1 = class MediaApiService {
  constructor(http, hostService) {
    this.http = http;
    this.hostService = hostService;
    this._host = this.hostService.hostWithScheme;
  }
  apiOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    };
  }
  createImage(r) {
    const request = r.toApiJson ? r : new CreateImageRequest(r);
    return this.http.post(this._host + "/media.v2.MediaService/CreateImage", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateImageResponse.fromProto(resp)));
  }
  getImage(r) {
    const request = r.toApiJson ? r : new GetImageRequest(r);
    return this.http.post(this._host + "/media.v2.MediaService/GetImage", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetImageResponse.fromProto(resp)));
  }
  createVideo(r) {
    const request = r.toApiJson ? r : new CreateVideoRequest(r);
    return this.http.post(this._host + "/media.v2.MediaService/CreateVideo", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateVideoResponse.fromProto(resp)));
  }
  getVideo(r) {
    const request = r.toApiJson ? r : new GetVideoRequest(r);
    return this.http.post(this._host + "/media.v2.MediaService/GetVideo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetVideoResponse.fromProto(resp)));
  }
  generateUploadUrl(r) {
    const request = r.toApiJson ? r : new GenerateUploadUrlRequest(r);
    return this.http.post(this._host + "/media.v2.MediaService/GenerateUploadUrl", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateUploadUrlResponse.fromProto(resp)));
  }
  getResumableUploadSession(r) {
    const request = r.toApiJson ? r : new GetResumableUploadSessionRequest(r);
    return this.http.post(this._host + "/media.v2.MediaService/GetResumableUploadSession", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetResumableUploadSessionResponse.fromProto(resp)));
  }
};
MediaApiService$1.ɵfac = function MediaApiService$1_Factory(t) {
  return new (t || MediaApiService$1)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
};
MediaApiService$1.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
  token: MediaApiService$1,
  factory: MediaApiService$1.ɵfac,
  providedIn: 'root'
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

class UploadImageResponse {
  static fromProto(proto) {
    if (!proto) {
      return null;
    }
    const m = new UploadImageResponse();
    if (Object.prototype.hasOwnProperty.call(proto, 'data')) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      m.data = proto.data;
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    if (kwargs.hasOwnProperty('data')) {
      this.data = kwargs.data;
    }
  }
  toApiJson() {
    if (typeof this.data === 'undefined') {
      return null;
    }
    return {
      'url': typeof this.data !== 'undefined' ? this.data : null
    };
  }
}

/**
 * This file is for the HTTP requests, since MSCLI only auto-generates lib/helper code for GRPC endpoints.
 */
let MediaUploadApi = /*#__PURE__*/(() => {
  class MediaUploadApi {
    constructor(hostService, http) {
      this.hostService = hostService;
      this.http = http;
    }
    upload(r) {
      return this.http.post(this.hostService.hostWithScheme + "/image/upload", r.form, this.apiOptions()).pipe(map(resp => UploadImageResponse.fromProto(resp)), catchError(err => this.handleError(err)));
    }
    get(imageId) {
      return this.hostService.hostWithScheme + "/image/get/" + imageId;
    }
    apiOptions() {
      return {
        withCredentials: true
      };
    }
    handleError(error) {
      if (error.error instanceof ErrorEvent) {
        console.error(`An error occurred:`, error.error.message);
      } else {
        console.error(error);
      }
      return throwError(() => "Unable to upload photo. Please try again.");
    }
  }
  MediaUploadApi.ɵfac = function MediaUploadApi_Factory(t) {
    return new (t || MediaUploadApi)(i0.ɵɵinject(HostService), i0.ɵɵinject(i1.HttpClient));
  };
  MediaUploadApi.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MediaUploadApi,
    factory: MediaUploadApi.ɵfac,
    providedIn: "root"
  });
  return MediaUploadApi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MediaApiService = /*#__PURE__*/(() => {
  class MediaApiService {
    constructor(grpcApi, mediaUploadApi) {
      this.grpcApi = grpcApi;
      this.mediaUploadApi = mediaUploadApi;
    }
    upload(file) {
      const formData = new FormData();
      formData.append('image', file, file.name);
      return this.mediaUploadApi.upload({
        form: formData
      }).pipe(map(resp => resp?.data || null));
    }
    create(servingUrl) {
      return this.grpcApi.createImage(new CreateImageRequest({
        servingUrl: servingUrl
      }));
    }
    get(imageId) {
      return this.mediaUploadApi.get(imageId);
    }
    getResumableUpload(mediaType, origin) {
      const request = new GetResumableUploadSessionRequest({
        mediaType: mediaType,
        origin: origin
      });
      return this.grpcApi.getResumableUploadSession(request);
    }
  }
  MediaApiService.ɵfac = function MediaApiService_Factory(t) {
    return new (t || MediaApiService)(i0.ɵɵinject(MediaApiService$1), i0.ɵɵinject(MediaUploadApi));
  };
  MediaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MediaApiService,
    factory: MediaApiService.ɵfac,
    providedIn: 'root'
  });
  return MediaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CreateImageRequest, CreateImageResponse, CreateVideoRequest, CreateVideoResponse, GenerateUploadUrlRequest, GenerateUploadUrlResponse, GetImageRequest, GetImageResponse, GetResumableUploadSessionRequest, GetResumableUploadSessionResponse, GetVideoRequest, GetVideoResponse, HostService, Image, MediaApiService, Tag, Video };
